export default __webpack_public_path__ + "static/media/notif_unshare_request.07e2623d.svg";